import { CSSProperties } from 'react';
import { lighterGray } from 'shared/styles/colors';

interface Props {
  viewBoxProp?: string;
  styleProp?: CSSProperties;
}

const NoSelection = ({ viewBoxProp, styleProp }: Props) => {
  const viewBox = viewBoxProp ?? "0 0 1000 1000";
  const style = styleProp ?? { zIndex: 0, position: 'relative', width: '100%', height: 'auto' };

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1000" height="1000" viewBox={viewBox} style={style}>
      <g id="Layer_2">
        <g>
          <polygon points="1000,974.82 1000,1000 974.82,1000 0,25.18 0,0 25.18,0"
            fill={lighterGray}
          />
        </g>
      </g>
    </svg>
  );
}

export default NoSelection;
